module.exports = __webpack_public_path__ + "img/S1051438.b7825526.jpg";